import React from 'react';
import useMetaLayoutContext from 'Components/UI/Meta/MetaForm/Components/MetaLayoutContext';
import {
  FDStack,
} from '@facet-wealth/design';
import { Benefit } from 'Views/Page/Content/Modal/Layouts/ScenarioAcceptanceIntroStep/Layout/Benefit';
import MetaControlField from 'Components/UI/Meta/MetaForm/Components/MetaControlField';
import { dataAttrs } from 'Helpers/Testing';
import { ScenarioAcceptContinueButton } from 'Views/Page/Content/Modal/Layouts/ScenarioAcceptCommon/ScenarioAcceptContinueButton';
import { DialogActions, DialogContent } from 'Views/Page/Content/Modal/Components';

const Layout = () => {
  const { onSubmit, resource } = useMetaLayoutContext();

  return (
    <>
      <MetaControlField attr={'title'} {...dataAttrs('select-your-scenario-intro-title')} />
      <DialogContent scrollKey={resource?.type() + resource?.id()}>
        <FDStack direction="column" alignItems={'center'} spacing={3}>
          <MetaControlField attr={'subtitle'} />
          <Benefit icon={'trendingUp'} text={'Facet Planning Engine'} />
          <Benefit icon={'checkCircleIcon'} text={'Daily Actions'} />
          <Benefit icon={'person'} text={'Personalized Advice'} />
          <ScenarioAcceptContinueButton resource={resource} onClick={onSubmit} label={'View my scenario'} />
        </FDStack>
      </DialogContent>
      <DialogActions>
        <ScenarioAcceptContinueButton resource={resource} onClick={onSubmit} label={'View my scenario'} />
      </DialogActions>
    </>
  );
};

export default Layout;
